import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useGoogleMaps } from '../../contexts/GoogleMapsContext';

export interface PlaceAddressMapPreviewProps {
  latitude?: number | null;
  longitude?: number | null;
  googleMapsUrl?: string | null;
  compact?: boolean;
}

function hasMapCoordinates(latitude?: number | null, longitude?: number | null): boolean {
  return (
    latitude != null &&
    longitude != null &&
    Number.isFinite(latitude) &&
    Number.isFinite(longitude)
  );
}

const PlaceAddressMapPreview: React.FC<PlaceAddressMapPreviewProps> = ({
  latitude,
  longitude,
  googleMapsUrl,
  compact = false,
}) => {
  const { isLoaded, loadError } = useGoogleMaps();

  if (!hasMapCoordinates(latitude, longitude)) {
    return null;
  }

  const position = { lat: latitude!, lng: longitude! };

  return (
    <Box
      sx={{
        height: compact ? 120 : { xs: 200, sm: 300 },
        width: '100%',
        borderRadius: 2,
        overflow: 'hidden',
        border: 1,
        borderColor: 'divider',
      }}
    >
      {!isLoaded ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress size={24} />
        </Box>
      ) : loadError ? null : (
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={position}
          zoom={15}
          options={{
            gestureHandling: 'cooperative',
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: true,
            clickableIcons: false,
          }}
        >
          <Marker
            position={position}
            onClick={() => {
              if (googleMapsUrl?.trim()) {
                window.open(googleMapsUrl, '_blank', 'noopener,noreferrer');
              }
            }}
          />
        </GoogleMap>
      )}
    </Box>
  );
};

export default PlaceAddressMapPreview;
